import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { XCircle, ArrowLeft, HelpCircle, MessageCircle } from 'lucide-react';
import Logo from '../../components/home/Logo';

const CheckoutCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-slate-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-lg w-full text-center">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <Logo className="h-12" showSocial={true} />
        </div>

        {/* Cancel Icon */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-100 rounded-full mb-6">
            <XCircle className="w-12 h-12 text-gray-400" />
          </div>
        </div>

        {/* Message */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Pagamento cancelado
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Não se preocupe, nenhuma cobrança foi feita.
          <br />
          Você pode tentar novamente quando quiser.
        </p>

        {/* Help section */}
        <div className="bg-white rounded-2xl border-2 border-gray-200 p-6 mb-8 text-left">
          <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
            <HelpCircle className="w-5 h-5 text-amber-500" />
            Teve algum problema?
          </h3>
          <ul className="space-y-3 text-gray-600 text-sm">
            <li className="flex items-start gap-3">
              <span className="text-amber-500">•</span>
              <span>Verifique se seu cartão está habilitado para compras online</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-amber-500">•</span>
              <span>Tente usar outro cartão de crédito</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-amber-500">•</span>
              <span>Entre em contato com seu banco se o problema persistir</span>
            </li>
          </ul>
        </div>

        {/* CTA Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/plans')}
            className="w-full py-4 px-6 bg-gradient-to-r from-amber-400 to-orange-500 hover:from-amber-500 hover:to-orange-600 text-white font-bold rounded-xl transition-all transform hover:scale-[1.02] shadow-lg"
          >
            Tentar novamente
          </button>
          
          <button
            onClick={() => navigate('/')}
            className="w-full py-4 px-6 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-xl transition-all flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-5 h-5" />
            Voltar para o início
          </button>
        </div>

        {/* Support link */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500 flex items-center justify-center gap-2">
            <MessageCircle className="w-4 h-4" />
            Precisa de ajuda?{' '}
            <a 
              href="mailto:suporte@hellosocial.com.br" 
              className="text-amber-600 hover:underline"
            >
              Fale conosco
            </a>
          </p>
        </div>

        {/* Reminder about free plan */}
        <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-xl">
          <p className="text-sm text-blue-800">
            💡 <strong>Dica:</strong> Você ainda pode usar o hello, social gratuitamente 
            com até 5 imagens por mês!
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;